// extracted by mini-css-extract-plugin
export default {"calendarBoxWrapper":"calendar_calendarBoxWrapper__LaktK","content":"calendar_content__jb0ON"};